import React from "react";

import { useAuthState } from "src/features/auth/hooks/useAuthState";
import { Coworker } from "src/features/auth/types";

export function useKnownUsers(): { [id: string]: Coworker } {
	const { user } = useAuthState();
	return React.useMemo(() => {
		const map: { [id: string]: Coworker } = {};
		if (user === null) {
			return map;
		}
		map[user.id] = user;
		for (const coworker of user.coworkers) {
			map[coworker.id] = coworker;
		}
		return map;
	}, [user]);
}
